import type { ComputedRef } from 'vue'
import type { User } from './interfaces'

import { useUsersStore } from './store'
import { useUserDelete } from '../api/delete.hook'
import { useUsersApi } from '../api/list.hook'

interface DeleteUserReturn {
  userToDelete: ComputedRef<User | null>
  isOpen: ComputedRef<boolean>
  isDeleting: ComputedRef<boolean>
  confirm: () => Promise<void>
  cancel: () => void
}

/** List-side delete: confirm the row targeted in the store, then refetch the current page. */
export const useDeleteUser = (): DeleteUserReturn => {
  const store = useUsersStore()

  const userToDelete = computed<User | null>(() => store.getUserToDelete)
  const isOpen = computed<boolean>(() => store.isModalDelete)
  const isDeleting = computed<boolean>(() => store.isSaving)

  const cancel = (): void => {
    store.setUserToDelete(null)
  }

  const confirm = async (): Promise<void> => {
    const user = store.getUserToDelete

    if (!user) return

    const ok = await useUserDelete(user.id)

    if (ok) {
      store.setUserToDelete(null)
      await useUsersApi()
    }
  }

  return { userToDelete, isOpen, isDeleting, confirm, cancel }
}
